import React, { useState,useContext } from 'react';
import styles from './editProfile.module.css'
import {IoMdAddCircle} from 'react-icons/io'
import { UserDataContext } from '../../../context/userData';
import axios from 'axios';
import { UserContext } from '../../../context/userContext';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';

const EditProfile=()=>{



const {userData,getUserData}=useContext(UserDataContext)
const {user}=useContext(UserContext);

const [loading,setLoading]=useState(false)
const [username,setUserame]=useState(userData.Username);
const [name,setName]=useState(userData.First_Name);
const [bio,setBio]=useState(userData.Bio);
const [title,setTitle]=useState(userData.Title);
const [country,setCountry]=useState(userData.Country)
const [gender,setGender]=useState(userData.Gender)



const [image,setImage]=useState();
 const [previmg,setPreviewImg]=useState(userData.Profile_Image)
 const handlefilechange=(e)=>{
    
        setImage(e.target.files[0]);

        if (e.target.files){
            setPreviewImg(URL.createObjectURL(e.target.files[0]));
        }
        var formdata =new FormData();
        formdata.append("user_id",user.userid);
         formdata.append("token",user.token);
         formdata.append("image",image)
        axios.post("https://vsam.me/api/api.php?request=imgupd",
           formdata
        ).then(res=>console.log(res)).catch(err=>console.log(err))
   

}

const handlePorfileChange=()=>{
    setLoading(true)
    axios.post("https://vsam.me/api/api.php?request=updateProfile",{
        user_id:user.userid,
        token:user.token,
        name:name,
        bio:bio,
        title:title,
        gender:gender,
        country:country
    }).then(res=>{
    toast.success(res.data.msg)
        getUserData();
        setLoading(false)
    })
}

    return(
        <div className={styles.container}>
            <div className={styles.pp}>
                <label htmlFor="selectpp">
                <img alt="profie pp" src={previmg}/>
                <IoMdAddCircle className={styles.editicon} />
                </label>
                <input id="selectpp" onChange={handlefilechange} style={{display:"none"}} accept=".png,.jpeg,.jpg"  type="file" />
            </div>

            <div className={styles.formsec}>
                <div className={styles.inputfiled}>
                    <label>Username</label>
                    <input onChange={e=>setUserame(e.target.value)} value={username}/>
                </div>
                <div className={styles.inputfiled}>
                    <label>Full Name</label>
                    <input  onChange={e=>setName(e.target.value)}  value={name}/>
                </div>
                <div className={styles.inputfiled}>
                    <label>Bio</label>
                    <input maxLength={120} onChange={e=>setBio(e.target.value)}  value={bio}/>
                </div>
                <div className={styles.inputfiled}>
                    <label>Title</label>
                    <input  onChange={e=>setTitle(e.target.value)}  value={title}/>
                </div>
                <div className={styles.inputfiled}>
                    <label>Country</label>
                    <input onChange={e=>setCountry(e.target.value)}  value={country}/>
                </div>
                <div className={styles.inputfiled}>
                    <label>Gender</label>
                    <select value={gender} onChange={(e)=>setGender(e.target.value)}>
                        <option value="male" >Male</option>
                        <option value="Female" >Female</option>
                        <option value="Prefer Not to Say">Prefer Not to Say</option>
                    </select>
                </div>
                {loading?
                <>
                <br/>
                <ReactLoading type={"spin"} color={"#7124BD"}   height={30} width={30} /></>:
                
                <button onClick={handlePorfileChange}  >Save</button>}

            </div>
        </div>
    )
}
export default EditProfile;